import * as React from "react";
import { UitkFigure } from "uitk-react-images";

interface DefaultWrapperProps {
  className?: string;
}
const DefaultWrapper: React.FC<DefaultWrapperProps> = ({ children, className }) => (
  <div className={className}>{children}</div>
);

const createWrapper = (Element: React.ComponentType<DefaultWrapperProps>) => (className?: string): React.FC => ({
  children,
}) => <Element className={className}>{children}</Element>;

export class WrapperFactory {
  public static get = (view?: string) => {
    const defaultClassNames = "AffinityRegion uitk-grid uitk-cell";
    const createDefaultContainer = createWrapper(DefaultWrapper);
    const createFigure = createWrapper(UitkFigure);

    switch (view) {
      case "affinity-full-width":
        return createDefaultContainer(`${defaultClassNames} fullWidth backgroundWhite`);
      case "affinity-container":
        return createDefaultContainer(`${defaultClassNames} affinityMain`);
      case "affinity-image":
        return createFigure(`${defaultClassNames} all-image-fit-cover affinityImage`);
      default:
        return createDefaultContainer();
    }
  };
}
